import { createModel } from '@rematch/core';
import { TASK_TYPE_MAP } from 'constants/pipeline';
import { post } from 'utils/http';

export default createModel()({
  state: {
    cleanModuleList: [], // 清洗模板列表
    crawlModuleList: [], // 抓取模板列表
    corpusSetList: [], // 语料集列表
  },
  reducers: {
    setState: (state: any, payload: any) => ({ ...state, ...payload }),
  },
  effects: {
    setReduxData({ key, data }) {
      this.setState({
        [key]: data,
      });
    },
    setQueryParams(data) {
      this.setState({
        queryParams: data,
      });
    },
    // 拉取任务列表
    async getPipelineTaskList(data = {}) {
      const rst = await post('/api/pipeline/getPipelineTaskList', data);
      return rst || {};
    },
    // 拉取语料集列表
    async getCorpusSetList(data = {}) {
      const rst = await post('/api/pipeline/getCorpusSetList', data);
      return rst || {};
    },
    // 拉取语料集数据
    async getCorpusSetItems(data = {}) {
      const rst = await post('/api/pipeline/getCorpusSetItems', data);
      return rst || {};
    },
    // 获取任务可配置模板
    async getTaskModuleTemplate(data = {}) {
      const rst = await post('/api/pipeline/getTaskModuleTemplate', data);
      if (rst) {
        const { taskType } = data;

        const { corpusSetList, taskModuleTmpls } = rst;
        // 根据不同的任务类型保存不同的数据
        if (taskType === TASK_TYPE_MAP.CRAWL.value) {
          // 抓取任务：只保存抓取模板列表
          this.setState({
            crawlModuleList: taskModuleTmpls?.crawlTmpls || [],
          });
        } else if (taskType === TASK_TYPE_MAP.CLEAN.value) {
          // 清洗任务：保存清洗模板列表和语料集列表
          this.setState({
            cleanModuleList: taskModuleTmpls?.cleanTmpls || [],
            corpusSetList: corpusSetList || [],
          });
        }
      }
      return rst || {};
    },
    // 获取任务详情
    async getTaskDetail(data = {}) {
      const rst = await post('/api/pipeline/getTaskDetail', data);
      return rst || {};
    },
    // 下载语料集数据
    async downloadCorpusSet(data = {}) {
      const rst = await post('/api/pipeline/downloadCorpusSet', data);
      return rst || {};
    },
    // 创建|更新任务
    async taskCreateOrUpdate(data = {}) {
      const rst = await post('/api/pipeline/taskCreateOrUpdate', data);
      return rst || {};
    },
    // 任务试运行
    async taskTrailRun(data = {}) {
      const rst = await post('/api/pipeline/taskTrailRun', data);
      return rst || {};
    },
    // 任务运行
    async taskRun(data = {}) {
      const rst = await post('/api/pipeline/taskRun', data);
      return rst || {};
    },
  },
});
